import { PanelData } from '../RolePanelTypes';
import { RecordsGrid } from './RecordsGrid';
import { RecordPropertyRolesGrid } from './RecordPropertyRolesGrid';
import { RolePanel } from '../rolePanel';

export class RecordPropertyRolePanel {
    recordRolePanelEl: HTMLElement;
    
    private rolePanel: RolePanel;
    private recordsGrid: RecordsGrid;
    recordPropertyRolesGrid: RecordPropertyRolesGrid;

    constructor(rolePanel: RolePanel) {
        this.rolePanel = rolePanel;        
    }

    destroy() {
        this.recordsGrid.api.destroy();
        if (this.recordPropertyRolesGrid.api !== null) {
            this.recordPropertyRolesGrid.api.destroy();        
        }
    }
    getSelectedRecordName() {
        return this.recordsGrid.api.getSelectedRows()[0].Name;        
    }
    private handleRecordSelectionChange() {
        this.recordPropertyRolesGrid.reload(`/${this.getSelectedRecordName()}/${this.rolePanel.getSelectedRole().Id}`, this.rolePanel.panelData)
    }
    async init(roleId: string, panelData: PanelData) {

        this.recordRolePanelEl = document.createElement('div');
        this.recordRolePanelEl.classList.add('recordRolePanel');

        await this.initRecordsGrid();
        await this.initRecordPropertyRolesGrid(this.recordsGrid.api.getSelectedRows()[0].Name, roleId, panelData);

        this.recordsGrid.api.addEventListener('selectionChanged', this.handleRecordSelectionChange.bind(this));
    }
    private async initRecordsGrid(): Promise<void>{
        this.recordsGrid = new RecordsGrid();
        await this.recordsGrid.init();
        this.recordRolePanelEl.appendChild(this.recordsGrid.gridContainer);
    }
    private async initRecordPropertyRolesGrid(recordName: string, roleId: string, panelData: PanelData) {
        this.recordPropertyRolesGrid = new RecordPropertyRolesGrid();
        await this.recordPropertyRolesGrid.initOrReload(`/${recordName}/${roleId}`, panelData);

        this.recordRolePanelEl.appendChild(this.recordPropertyRolesGrid.gridContainer);
    }
}